import { Grid2, Stack, Typography, useTheme } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { ActionFieldInputComponent } from "../Inputs/ActionFieldInputComponent";
import { useTranslation } from "react-i18next";
import { ActionMultivalue } from "src/components/Actions/Tabs/2_TabActionPlan/context/utils/formatMultivalue/formatMultivalue";
import { PreviousValue } from "../Common/PreviousValue";

type Props = {
    actionMultivalue: ActionMultivalue | null;
};
export const ManySubproperty = (props: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { actionMultivalue } = props;

    if (actionMultivalue === null) {
        return null;
    }

    return (
        <Stack gap={theme.spacing(3)}>
            {actionMultivalue.rows.map((row) => {
                return (
                    <Grid2
                        key={row.position}
                        border={`1px solid ${theme.custom.grey[600]}`}
                        borderRadius={theme.spacing(1.5)}
                        columns={12}
                        container
                    >
                        {/* Firstline */}
                        <Grid2
                            sx={{
                                borderTopLeftRadius: theme.spacing(1.5),
                                borderTopRightRadius: theme.spacing(1.5),
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                            }}
                            padding={theme.spacing(2)}
                            bgcolor={theme.custom.grey[200]}
                            borderBottom={`1px solid ${theme.custom.grey[600]}`}
                            size={12}
                        >
                            <Typography variant="body-bold">{row.rowHierarchy.label}</Typography>
                        </Grid2>
                        {/* Action Field lines */}
                        {row.actionFieldByMulti.map((subproperty) => {
                            const fieldValue = subproperty.fieldValue;
                            const startingValue = subproperty.startingValue;

                            return (
                                <Fragment key={subproperty.actionFieldId}>
                                    <Grid2 size={6} padding={theme.spacing(2)} alignContent={"center"}>
                                        <Typography variant="body-bold">{subproperty.question}</Typography>
                                    </Grid2>
                                    <Grid2 size={6} padding={theme.spacing(2)}>
                                        <Stack gap={theme.spacing(1)}>
                                            <ActionFieldInputComponent
                                                fieldValue={fieldValue}
                                                unit={subproperty.unit}
                                                dataListOptions={subproperty.dataListOptions}
                                                fieldType={subproperty.fieldType}
                                                disabled={subproperty.disabled}
                                                position={subproperty.position}
                                                actionFieldId={subproperty.actionFieldId}
                                            />
                                            {startingValue.value !== undefined && (
                                                <PreviousValue
                                                    year={startingValue.label}
                                                    value={startingValue.value}
                                                    unit={startingValue.unit}
                                                />
                                            )}
                                        </Stack>
                                    </Grid2>
                                </Fragment>
                            );
                        })}
                    </Grid2>
                );
            })}
        </Stack>
    );
};
